import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { X_STACK_GUI_FIELDS } from "./XStack.settings";
const { Général: GEN, Placements, ...REST } = X_STACK_GUI_FIELDS;

export const X_CAROUSEL_GUI_FIELDS: TXGUISection = {
  Général: [
    ...(GEN ?? []),
    {
      type: "select_option",
      name: "columns",
      label: "Colones",
      options: [
        { value: 1, label: "1 Colone" },
        { value: 2, label: "2 Colones" },
        { value: 3, label: "3 Colones" },
        { value: 4, label: "4 Colones" },
        { value: 5, label: "5 Colones" },
        { value: 6, label: "6 Colones" },
        { value: 7, label: "7 Colones" },
        { value: 8, label: "8 Colones" },
      ],
      defaultValue: 1,
    },
    {
      type: "toggle_option",
      name: "align",
      label: "Alignement",
      options: [
        { value: "prev", label: "Gauche" },
        { value: "center", label: "Centre" },
        { value: "next", label: "Droite" },
      ],
      defaultValue: "prev",
    },
    {
      type: "toggle_option",
      name: "loop",
      label: "En Boucle",
      options: [
        {
          value: false,
          label: "Non",
        },
        { value: true, label: "Oui" },
      ],
      defaultValue: false,
    },

    {
      type: "toggle_option",
      name: "autoPlay",
      label: "Automatique",
      options: [
        {
          value: false,
          label: "Non",
        },
        { value: true, label: "Oui" },
      ],
      defaultValue: false,
    },
  ],
  "Indicateurs de position": [
    {
      type: "toggle_option",
      name: "dotMode",
      label: "Type",
      options: [
        { value: "bullet", label: "Normal" },
        { value: "fraction", label: "Fraction" },
        { value: "scroll", label: "Fondu" },
        { value: "none", label: "Aucun" },
      ],
      defaultValue: "bullet",
    },
    {
      type: "color",
      name: "dotColor",
      label: "Couleur",
      defaultValue: "#f2a65e",
    },
    {
      type: "sizing",
      name: "dotWidth",
      label: "Largeur",
    },
    {
      type: "sizing",
      name: "dotHeight",
      label: "Hauteur",
    },
    {
      type: "border",
      name: "dotBorder",
      label: "Bordure",
      units: ["px", "em"],
    },
    {
      type: "radius",
      name: "dotRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
  ],
  "Indicateurs de position (Actifs)": [
    {
      type: "color",
      name: "dotActivedColor",
      label: "Couleur d'arriere plan",
    },
    {
      type: "sizing",
      name: "dotActivedWidth",
      label: "Largeur",
    },
    {
      type: "sizing",
      name: "dotActivedHeight",
      label: "Hauteur",
    },
    {
      type: "border",
      name: "dotActivedBorder",
      label: "Bordure",
      units: ["px", "em"],
    },
  ],
  "Flèches de direction": [
    {
      type: "toggle_option",
      name: "arrowVisibility",
      label: "Visibilité",
      options: [
        { value: "always", label: "Toujours" },
        { value: "hover", label: "Survolé" },
        { value: "none", label: "Aucun" },
      ],
      defaultValue: "always",
    },
    {
      type: "toggle_option",
      name: "arrowPosition",
      label: "Emplacement",
      options: [
        { value: "in", label: "Interieur" },
        { value: "out", label: "Exterieure" },
      ],
      defaultValue: "in",
    },
    {
      type: "toggle_option",
      name: "arrowWeight",
      label: "Epaisseur",
      options: [
        { value: "thin", label: "Mince" },
        { value: "bold", label: "Gras" },
      ],
      defaultValue: "bold",
    },
    {
      type: "color",
      name: "arrowColor",
      label: "Couleur",
      defaultValue: "#f2a65e",
    },
    {
      type: "sizing",
      name: "arrowFontSize",
      label: "Taille de la Flèches",
      units: ["px"],
      defaultValue: "25px",
    },
    {
      type: "sizing",
      name: "arrowWidth",
      label: "Largeur de la Flèches",
      units: ["px"],
    },
    {
      type: "sizing",
      name: "arrowHeight",
      label: "Hauteur de la Flèches",
      units: ["px"],
    },
    {
      type: "color",
      name: "arrowBgColor",
      label: "Couleur de l'arriere plan",
    },
    {
      type: "border",
      name: "arrowBorder",
      label: "Contour de la Flèches",
    },
    {
      type: "radius",
      name: "arrowRadius",
      label: "Arrondis de la Flèches",
    },
  ],
  "Flèches de direction (Survolées)": [
    {
      type: "color",
      name: "arrowHoverColor",
      label: "Couleur",
      defaultValue: "#f2a65e",
    },
    {
      type: "sizing",
      name: "arrowHoverFontSize",
      label: "Taille de la Flèches",
      units: ["px"],
      defaultValue: "25px",
    },
    {
      type: "sizing",
      name: "arrowHoverWidth",
      label: "Largeur de la Flèches",
      units: ["px"],
    },
    {
      type: "sizing",
      name: "arrowHoverHeight",
      label: "Hauteur de la Flèches",
      units: ["px"],
    },
    {
      type: "color",
      name: "arrowHoverBgColor",
      label: "Couleur de l'arriere plan",
    },
    {
      type: "border",
      name: "arrowHoverBorder",
      label: "Contour de la Flèches",
    },
    {
      type: "radius",
      name: "arrowHoverRadius",
      label: "Arrondis de la Flèches",
    },
  ],
  ...REST,
};
